import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import baustein from "baustein";
import GenericOverlay from "web/script/components/overlays/generic-overlay";
export default baustein.register("generic-overlay-launcher", {
  defaultOptions: {
    contentUrl: null,
    eventCategory: null,
    eventAction: null,
    eventLabel: null,
    overlaySize: "large"
  },
  setupEvents: function setupEvents(add) {
    add("click", this.launchOverlay);
  },
  launchOverlay: function launchOverlay(event) {
    var _this = this;

    event.preventDefault();
    var existing = baustein.getInstancesOf("generic-overlay"); // close any existing overlays

    Promise.all(existing.map(function (overlay) {
      return overlay.close();
    })).then(function () {
      // now destroy them
      existing.forEach(function (overlay) {
        return overlay.destroy();
      });
      var contentUrl = _this.options.contentUrl || _this.el.href;
      var overlay = new GenericOverlay({
        contentUrl: contentUrl,
        eventCategory: _this.options.eventCategory,
        eventAction: _this.options.eventAction,
        eventLabel: _this.options.eventLabel,
        overlaySize: _this.options.overlaySize
      }); // dirty but appending the overlay into an `<a>` does wierd things...

      overlay.appendTo(document.body);
      overlay.open();
    });
  }
});